export * from './TInformationTooltipDesktopTheme';
export * from './IInformationTooltipDesktopProps';